import { render, staticRenderFns } from "./DisponibilizarAluguelDialog.vue?vue&type=template&id=36fe1e64&"
import script from "./DisponibilizarAluguelDialog.vue?vue&type=script&lang=js&"
export * from "./DisponibilizarAluguelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports